import React, { useEffect, useState, lazy, Suspense} from 'react'
import { useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { gsap } from 'gsap'
import { supabase } from '../../service/api.tsx'
import TransitionLink from '../../transitions/TransitionLink'
import './project.css'

const DetailItem = lazy(() => import('../../components/Detail/Detail.tsx'));

export default function Project() {
 const { id } = useParams();
 const [project, setProject] = useState()
 const [loading, setLoading] = useState(true)
 const [details, setDetails] = useState([{descriptions: [], imgs: []}])
 const [arrTag, setArrTag] = useState([])
 const [sD, setSD] = useState()

 useEffect(() => {
  const fetchData = async () => {
    let { data, error } = await supabase
      .from('projects')
      .select("id, name, shortdescription, thumbnail, project_descriptions(description), project_images(img), project_tags(tag), project_links(link)")
      .eq('id', id)
      .single();

    if (error) {
      console.error(error);
      setLoading(false);
    } else {
      setProject(data);
      setDetails([{ descriptions: data?.project_descriptions, imgs: data?.project_images, tags: data?.project_tags }]);
      setArrTag(data?.project_tags.map(tag => tag.tag));
      setLoading(false);
      setSD(data?.shortdescription)
    }
  };

  fetchData();
}, [id]);

useEffect(() => {
  if (!loading) {
    gsap.from('.project-thumbnail', { duration: 1, opacity: 0, y: -40, ease: 'power3.out' });
    gsap.from('.project-page .container-title', { duration: 0.9, opacity: 0, y: 20, delay: 0.2, ease: 'power3.out' });
  }
}, [loading]);

  return (  
    <div className="project-page">
      {loading && <p className="loading-text">Chargement...</p>}
      <Helmet>
        <meta name='description' content={`${sD}`}></meta>
        <meta name='keyword' content={`${arrTag.join(', ')}`}></meta>
      </Helmet>
      {project &&
      <div>
        <TransitionLink to="/#projects" className="back-link">← Retour aux projets</TransitionLink>
        <img className={'project-thumbnail'} src={project.thumbnail} alt={`screen du projet ${project.name}`} />
        <div className={'container-title'}>
          <h1 className={'title'}><a className='link title' href={project.project_links[0].link} target="_blank" rel="noreferrer">{project.name}</a></h1>
        </div>
        <div className={"container"}>
  {details.map((detail, i) => (
    <Suspense fallback={<p className="loading-text">Chargement...</p>} key={i}>
      <DetailItem detail={detail} index={i}/>
    </Suspense>
  ))}
</div>
      </div>
      }
    </div>
  )
}
